import React , {useEffect} from 'react'
import { useLocation } from "react-router-dom";
import './HaptikChatIcon.scss'

const ChatIcon = () => {
  const location = useLocation();
  const hiddenRoutes = ["/booking", "/booking/:id", "/seat-arrangement", "/stops", "/booking-details", "/payment", '/coupon-list', '/ticket-view', '/change-booking']; // Add routes where you want to HIDE it
  const pathname = window.location.pathname;



 useEffect(() => {
    // Prevent multiple script injections
    if (typeof window === "undefined") return;
    if (window.HaptikSDK) return;

    window.haptikInitSettings = {
      "business-id": "6167",
      "client-id": process.env.REACT_APP_HAPTI_CLIENT_ID,
      "base-url": process.env.REACT_APP_HAPTI_BASE_URL,
      "custom-button": true,
      "attachment-file-types": "pdf, xls ,jpg, jpeg, png",
      "file-attachment-icon-visibility": "always",
    };

    const script = document.createElement("script");
    script.src = "https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js";
    script.type = "text/javascript";
    script.charset = "UTF-8";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  if (hiddenRoutes.includes(pathname)) {
    return null;
  }

  const openChat = () => {
    if (window.HaptikSDK && window.HaptikSDK.show) {
      window.HaptikSDK.show();
    }
  };

    if (hiddenRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <div className="custom-icon" onClick={() => openChat()}>
      <img
        src="https://production-nuego-cms.blr1.cdn.digitaloceanspaces.com/static-contents/production/Chat-Solid.svg"
        alt="NueGo Help ChatBot Support"
      />
      <p>Chat</p>
    </div>
  );
};

export default ChatIcon;
